import {Buyout} from '../../core/_models/_buyout-models'
import {BuyoutStatusItem} from './BuyoutStatusItem'
import {FormattedMessage, useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {getBuyoutStatuses} from '../../core/_requests'
import {CParcelStatusItem} from '../../../../parcels/parcel-page/status/CParcelStatusItem'
import {CBuyoutStatusItem} from './CBuyoutStatusItem'

interface Props {
  buyout: Buyout
}

export function BuyoutStatus({buyout}: Props) {
  const intl = useIntl()
  const {data: buyoutStatuses} = useQuery(
    ['buyoutStatuses', intl.locale, buyout.id],
    () => {
      return getBuyoutStatuses(buyout.id)
    },
    {keepPreviousData: true, retry: false}
  )

  const {statuses} = buyout

  return (
    <div className='card mb-5 mb-xl-10 pt-10'>
      <div className='card-body py-9 px-20 cardBody'>
        <div className='table-responsive'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-190px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.DATE_COLUMN' />
                </th>

                <th className='min-w-120px'>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.STATUS_COLUMN' />
                </th>
                <th className='min-w-100px '>
                  <FormattedMessage id='PARCELS.P_PAGE.STATUSES.AUTHOR_COLUMN' />
                </th>
              </tr>
            </thead>

            <tbody>
              {buyoutStatuses?.statusLogs?.length &&
                buyoutStatuses.statusLogs?.map((item: any, index: number) => (
                  <CBuyoutStatusItem key={index} log={item} />
                ))}
              {!buyoutStatuses?.statusLogs?.length &&
                statuses.map((item) => <BuyoutStatusItem key={item.id_status} log={item} />)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
